import Phaser from 'phaser';
import { GAME_MODE, setGameMode } from '../systems/GameMode';
import { mountMenu, element, button, header, go, primaryShortcut } from '../util/menuUI';

export class GameModeScene extends Phaser.Scene {
  constructor() {
    super('GameModeScene');
  }

  create() {
    const root = mountMenu(this, 'tmag-mode-select');

    header(root, 'ELIGE TU MODO DE JUEGO', '', '← INICIO', () => go(this, 'MenuScene'));

    const grid = element('div', 'tmag-mode-grid');
    const selectMode = (mode) => go(this, 'GalaxyScene', () => {
      setGameMode(this.registry, mode);
    });

    const createModeCard = (mode, icon, title, description, actionLabel, variant) => {
      const card = element('article', `tmag-card tmag-mode-card tmag-mode-card--${variant}`);

      card.append(
        element('div', 'tmag-mode-icon', icon),
        element('h2', '', title),
        element('p', 'tmag-mode-description', description),
        button(
          actionLabel,
          () => selectMode(mode),
          'tmag-button tmag-primary tmag-mode-action',
        ),
      );

      return card;
    };

    grid.append(
      createModeCard(
        GAME_MODE.COMPETITION,
        '🚀',
        'MODO AVENTURA',
        'Explora los sistemas estelares, domina cada planeta y consigue tu mejor puntuación.',
        'COMENZAR AVENTURA',
        'competition',
      ),
      createModeCard(
        GAME_MODE.PRACTICE,
        '🎯',
        'MODO PRÁCTICA',
        'Entrena a tu ritmo y fortalece tus habilidades.',
        'COMENZAR PRÁCTICA',
        'practice',
      ),
    );

    root.append(grid);
    primaryShortcut(root, () => selectMode(GAME_MODE.COMPETITION));
  }
}
